import React from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'

class FancyInput extends React.Component {
    componentDidMount () {
        if (this.props.value && this.props.value.length > 0) {
            this.input.classList.add('input--filled')
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.value !== this.props.value && this.props.value.length > 0) {
            this.input.classList.add('input--filled')
        }
    }

    handleFocus (event) {
        event.target.parentNode.classList.add('input--filled')

        if (this.props.handleFocus) {
            this.props.handleFocus(event)
        }
    }

    handleBlur (event) {
        if (event.target.value.trim() === '') {
            event.target.parentNode.classList.remove('input--filled')
        }

        globals.setSessionVar(event.target.name, event.target.value)
    }

    hasErrors () {
        return this.props.errors && this.props.errors[this.props.name]
    };

    render () {
        return (
            <span className={`input input--nao ${this.props.filled ? 'input--filled' : ''} ${this.hasErrors() ? 'error' : ''}`} ref={el => this.input = el}>
                <input
                    name={this.props.name}
                    className='input__field input__field--nao'
                    value={this.props.value}
                    maxLength={(this.props.maxLength ? this.props.maxLength : 255)}
                    onFocus={this.handleFocus.bind(this)}
                    onBlur={this.handleBlur.bind(this)}
                    onChange={this.props.handleChange}
                    onKeyDown={this.props.handleKeyDown}
                    type={this.props.type ? this.props.type : 'text'}
                    autoComplete={this.props.autoComplete ? this.props.autoComplete : ''}
                />
                <label className='input__label input__label--nao'>
                    <span className='input__label-content input__label-content--nao'>
                        {this.props.label}
                    </span>
                </label>
                <svg className='graphic graphic--nao' width='300%' height='100%' viewBox='0 0 1200 60' preserveAspectRatio='none'>
                    <path d='M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0' />
                </svg>
            </span>
        )
    }
}

FancyInput.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    filled: PropTypes.bool,
    type: PropTypes.string,
    maxLength: PropTypes.number,
    handleChange: PropTypes.func.isRequired,
    handleFocus: PropTypes.func,
    handleBlur: PropTypes.func,
    handleKeyDown: PropTypes.func,
    errors: PropTypes.object
}

FancyInput.defaultProps = {
    value: ''
}

export default FancyInput



// WEBPACK FOOTER //
// ./resources/js/elements/FancyInput.js